import { pathBuilder } from 'config/paths/index';

export const root = '/admin/contacts';
export default pathBuilder(root);
